import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors, Hidden } from "@material-ui/core";
import InvTotal from "../../AFReadyDisigen/A4/InvTotal";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import TotalsInvCom from "../../AFReadyDisigen/A4/TotalsInvCom";
import { cellSName,styleNo } from "../../ShareFunctionsPrint";
import "../../AFReadyDisigen/invoiceprint.css"
const BodyInv = (props) => {
  const cls = useRptAF();
  const { data, isLast, inv, sta, found,locInv, premiApp ,} = props;



  var columns = [
    { title: "No \n م", field: "no", cellStyle: styleNo },
    {title: "Item Name \n اسم الصنف", field: "notesall",cellStyle:cellSName,},
      // render: (parms) => ( <div className={parms.symbol?.length>20?"cellslarge":"cellslow"}> {parms.symbol}</div>)},
    { title: "Quantity \n الكمية ", field: "val1" ,},
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: sta?.tot?.re_disc ?"Retention \n خصم ضمان": "Discount \n الخصم", field: "discount",hidden:premiApp.billTemplate === 27?true:false },
    { title: "BeforeVat \n الخاضع للضريبة", field: "totBill", },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval", },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr", },
  ];

  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: premiApp.billTemplate === 27 ? "ltr" : "rtl", border: "dotted 1px #393939",
        }}>
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none", width: "100%", tableLayout: "fixed" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={columns.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))}
            data={data}
          />
          {premiApp.billTemplate === 27 ?
            (isLast && <TotalsInvCom found={found} inv={inv} sta={sta} locInv={locInv} />) :
            (isLast && <InvTotal inv={inv} sta={sta} premiApp={premiApp} locInv={locInv}/>)}
        </Grid>
      </Grid>

    </Grid>
  );
};

export default BodyInv;
